export default "/fonts/Muli-SemiBold.ttf?534f8b00662d5445104d6f68956c97df";